import React from "react";

function Btn({ text, border }: { text: string; border?: boolean }) {
  return (
    <button className="text-sm border-white hover:bg-white bg-transparent hover:text-black border-2 w-max py-3 px-10 uppercase font-semibold">
      {text}
    </button>
  );
}

export default Btn;
